import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScaleBarComponent } from './scale-bar.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ScaleBarComponent],
  exports: [ScaleBarComponent],
})
export class ScaleBarModule {}
